<template>
  <div class="h-100">
    <router-view />
  </div>
</template>

<script>
// examplex
import { mapActions, mapState } from "vuex";

// Constantes
import { getDashboard } from "./constants/dashboard";
import { validateToken } from "./constants/general";

//import { getListarPermisos } from "./constants/administracion";

export default {

  methods: {
    // State generales
    ...mapActions([
      "AccionCambiarToken",
      "AccionCambiarAdmin",
      "ActionSetPaises",
      "ActionSetZonas",
      "ActionSetRegiones",
      "ActionSetProvincias",
      "ActionSetComunas",
      "ActionSetLocalidades",
      "ActionSetDirecciones",
      "ActionSetDestinos",
      "ActionSetPuertos",
      "ActionSetLoading",
      "AccionCambiarUsuarioActual",
      "ActionSetClientes",
      "ActionSetNavieras",
      "ActionSetNaves",
      "ActionSetComerciales",
      "ActionSetProductos",
      "ActionSetTipoServicioIntegral",
      "ActionSetMotivo",
      "ActionSetListaClientesUsuarioActual",
      "ActionSetTipoContratos",
      "ActionSetCommodity",
      "ActionSetAtmosferas",
      "ActionSetContenedores",
      "ActionSetServicioIntegral",
      "ActionSetEstadoAcuerdoLinea",
      "ActionSetPod",
      "ActionSetPol",
      "ActionSetAvatarMiniatura"
    ]),

    // Modulos de acceso
    ...mapActions("modulosLogin", [
      "AccionCambiarIsSuperAdministrador",
      "AccionCambiarIsAdministracion",
      "AccionCambiarIsLineas",
      "AccionCambiarIsCharter",
      "AccionCambiarIsServIntegral",
      "AccionCambiarIsFinanzas",
      "AccionCambiarIsShipping",
    ]),

    // Secciones para modulo Administración
    ...mapActions("seccionesSuperAdministrador", [
      "AccionCambiarIsFiliales",
      "AccionCambiarIsRoles",
      "AccionCambiarIsMantenedorRegional",
      "AccionCambiarIsModulos",
      "AccionCambiarIsRoles",
      "AccionCambiarIsSecciones",
    ]),

    // Secciones para modulo Administración
    ...mapActions("seccionesAdministrador", [
      "AccionCambiarIsClientes",
      "AccionCambiarIsUsuarios",
      "AccionCambiarIsPerfil",
      "AccionCambiarIsProveedores",
      "AccionCambiarIsPuertos",
      "AccionCambiarIsDestinos",
      "AccionCambiarIsContenedores",
      "AccionCambiarIsCondiciones",
      "AccionCambiarIsNaves",
      "AccionCambiarIsNavieras",
      "AccionCambiarIsProductos",
      "AccionCambiarIsLimitePlanificaciones",
      "AccionCambiarIsTemporadas",
      "AccionCambiarIsEmbarcador",
    ]),

    // Secciones para modulo Lineas
    ...mapActions("seccionesLineas", [
      "AccionCambiarIsBuscarBL",
      "AccionCambiarIsPlanificacionAnual",
      "AccionCambiarIsPlanificacionSemanal",
      "AccionCambiarIsServicios",
      "AccionCambiarIsBooking",
      "AccionCambiarIsGeneral",
      "AccionCambiarIsTarifas",
      "AccionCambiarIsItinerarios",
      "AccionCambiarIsTracking",
    ]),

     // Secciones para modulo Charter
    ...mapActions("seccionesCharter", [
      "AccionSetIsPlanificacionAnual",
      "AccionSetIsPlanificacionMensual",
      "AccionSetIsServicios",
      "AccionSetIsDeclaracionPorNave",
      "AccionSetIsGeneral",
      "AccionSetIsItinerarios"
    ]),

    // Secciones para modulo Shipping Instructions
    ...mapActions("seccionesShippingInstructions", [
      "AccionCambiarIsPorEnviar",
      "AccionCambiarIsPorAprobar",
      "AccionCambiarIsPorRealizar",
      "AccionCambiarIsEnviados",
      "AccionCambiarIsConfirmados",
      "AccionCambiarIsRechazados",
      "AccionCambiarIsTemplates",
      "AccionCambiarIsReporte",
    ]),

    ...mapActions("subseccionesLineas", [
      "AccionCambiarIsBookingDeclarados",
      "AccionCambiarIsBookingsSolicitados",
      "AccionCambiarIsBookingsConfirmados",
      "AccionCambiarIsSolicitudModificacion",
      "AccionCambiarIsBookingsEmbarcados",
      "AccionCambiarIsBookingsCancelados",
      "AccionCambiarIsVerDeclaradosCancelado",
      "AccionCambiarIsLateArrivals",
    ]),

    // Función que filtra a que modulos podrá acceder el usuario logueado
    asignacionPermisosModulos(modulos) {
      Object.keys(modulos).map((modulo) => {
        if (modulos[modulo].toLowerCase() == "super administrador") {
          this.AccionCambiarIsSuperAdministrador(true);
        } else if (modulos[modulo] == "Administración") {
          this.AccionCambiarIsAdministracion(true);
        } else if (modulos[modulo] == "Lineas") {
          this.AccionCambiarIsLineas(true);
        } else if (modulos[modulo] == "Charter") {
          this.AccionCambiarIsCharter(true);
        } else if (modulos[modulo] == "Serv. Integral") {
          this.AccionCambiarIsServIntegral();
        } else if (modulos[modulo] == "Serv. Integral - Finanzas") {
          this.AccionCambiarIsFinanzas(true);
        } else if (modulos[modulo] == "Shipping Instruction") {
          this.AccionCambiarIsShipping(true);
        }
      });
    },

    // Función que filtra a que secciones podrá acceder el usuario logueado
    asignacionPermisosSecciones(secciones) {
      Object.keys(secciones).map((seccion) => {

        // Super Administrador
        if (secciones[seccion] == "Filiales") {
          this.AccionCambiarIsFiliales(true);
        } else if (secciones[seccion] == "Mantenedor Regional") {
          this.AccionCambiarIsMantenedorRegional(true);
        } else if (secciones[seccion] == "Modulos") {
          this.AccionCambiarIsModulos(true);
        } else if (secciones[seccion] == "Roles") {
          this.AccionCambiarIsRoles(true);
        } else if (secciones[seccion] == "Secciones") {
          this.AccionCambiarIsSecciones(true);
          // Administración
        } else if (secciones[seccion] == "Clientes") {
          this.AccionCambiarIsClientes(true);
        } else if (secciones[seccion] == "Usuarios") {
          this.AccionCambiarIsUsuarios(true);

        } else if (secciones[seccion] == "Proveedores") {
          this.AccionCambiarIsProveedores(true);
        } else if (secciones[seccion] == "Puertos") {
          this.AccionCambiarIsPuertos(true);
        } else if (secciones[seccion] == "Destinos") {
          this.AccionCambiarIsDestinos(true);
        } else if (secciones[seccion] == "Contenedores") {
          this.AccionCambiarIsContenedores(true);
        } else if (secciones[seccion] == "Condiciones") {
          this.AccionCambiarIsCondiciones(true);
        } else if (secciones[seccion] == "Naves") {
          this.AccionCambiarIsNaves(true);
        } else if (secciones[seccion] == "Navieras") {
          this.AccionCambiarIsNavieras(true);
        } else if (secciones[seccion] == "Categorias Productos") {
          this.AccionCambiarIsProductos(true);
        } else if (secciones[seccion] == "LimitePlanificaciones") {
          this.AccionCambiarIsLimitePlanificaciones(true);
        } else if (secciones[seccion] == "Temporadas") {
          this.AccionCambiarIsTemporadas(true);
        } else if (secciones[seccion] == "Embarcador") {
          this.AccionCambiarIsEmbarcador(true);

          // Lineas
        } else if (secciones[seccion] == "Buscar BL") {
          this.AccionCambiarIsBuscarBL(true);
        } else if (secciones[seccion] == "Planificación Anual") {
          this.AccionCambiarIsPlanificacionAnual(true);
        } else if (secciones[seccion] == "Planificacion Semanal") {
          this.AccionCambiarIsPlanificacionSemanal(true);
        } else if (secciones[seccion] == "Servicios") {
          this.AccionCambiarIsServicios(true);
        } else if (secciones[seccion] == "Booking") {
          this.AccionCambiarIsBooking(true);
        } else if (secciones[seccion] == "General") {
          this.AccionCambiarIsGeneral(true);
        } else if (secciones[seccion] == "Tarifas") {
          this.AccionCambiarIsTarifas(true);
        } else if (secciones[seccion] == "Itinerarios") {
          this.AccionCambiarIsItinerarios(true);
        } else if (secciones[seccion] == "Tracking") {
          this.AccionCambiarIsTracking(true);

        } else if (secciones[seccion] == "Planificacion Anual") {
          this.AccionSetIsPlanificacionAnual(true);

          // Shipping Instructions
        } else if (secciones[seccion] == "Shipp. Instruct. por Enviar") {
          this.AccionCambiarIsPorEnviar(true);
        } else if (secciones[seccion] == "Shipp. Instruct. por Aprobar") {
          this.AccionCambiarIsPorAprobar(true);
        } else if (secciones[seccion] == "Shipp. Instruct. por Realizar") {
          this.AccionCambiarIsPorRealizar(true);
        } else if (secciones[seccion] == "Shipp. Instruct. Enviados") {
          this.AccionCambiarIsEnviados(true);
        } else if (secciones[seccion] == "Shipp. Instruct. Confirmados") {
          this.AccionCambiarIsConfirmados(true);
        } else if (secciones[seccion] == "Shipp. Instruct. Rechazados") {
          this.AccionCambiarIsRechazados(true);
        } else if (secciones[seccion] == "Templates") {
          this.AccionCambiarIsTemplates(true);
        } else if (secciones[seccion] == "Reportes") {
          this.AccionCambiarIsReporte(true);
        }
      });

      this.AccionCambiarIsPerfil(true);

    },

    // Función que filtra a que subsecciones podrá acceder el usuario logueado
    asignacionPermisosSubsecciones(subsecciones) {

      Object.keys(subsecciones).map((sub) => {

        // Administración
        if (subsecciones[sub] == 'Clientes') {
          this.AccionCambiarIsClientes(true);
        } else if (subsecciones[sub] == 'Usuarios') {
          this.AccionCambiarIsUsuarios(true);
        } else if (subsecciones[sub] == 'Categorias Productos') {
          this.AccionCambiarIsProductos(true);
        } else if (subsecciones[sub] == 'Proveedores') {
          this.AccionCambiarIsProveedores(true);
        } else if (subsecciones[sub] == 'Puertoss') {
          this.AccionCambiarIsPuertos(true);
        } else if (subsecciones[sub] == 'Destinos') {
          this.AccionCambiarIsDestinos(true);
        } else if (subsecciones[sub] == 'Pallets') {
          // this.AccionCambiarIsPallets(true);
        } else if (subsecciones[sub] == 'Condiciones') {
          this.AccionCambiarIsCondiciones(true);
        } else if (subsecciones[sub] == 'Naves') {
          this.AccionCambiarIsNaves(true);
        } else if (subsecciones[sub] == 'Navieras') {
          this.AccionCambiarIsNavieras(true);
        } else if (subsecciones[sub] == 'Límite Planificaciones') {
          this.AccionCambiarIsLimite(true);
        } else if (subsecciones[sub] == 'Temporadas') {
          this.AccionCambiarIsTemporadas(true);
        } else if (subsecciones[sub] == 'Embarcador') {
          this.AccionCambiarIsEmbarcador(true);
        } else if (subsecciones[sub] == 'Contenedores') {
          this.AccionCambiarIsContenedores(true);
        } else if (subsecciones[sub] == 'Depósitos') {
          // this.AccionCambiarIsDepositos(true);
        // } else if (subsecciones[sub] == 'Atmósferas') {
        // //   this.AccionCambiarIsAtmosferas(true);
        // } else if (subsecciones[sub] == 'Tipos de movimientos') {
        //   this.AccionCambiarIsTipos(true);
        // } else if (subsecciones[sub] == 'Zonas de consolidación') {
        //   this.AccionCambiarIsZonas(true);
        // } else if (subsecciones[sub] == 'Países') {
          // this.AccionCambiarIsPaises(true);
        // } else if (subsecciones[sub] == 'Regiones') {
        //   this.AccionCambiarIsRegiones(true);
        // } else if (subsecciones[sub] == 'Provincias') {
        //   this.AccionCambiarIsProvincias(true);
        // } else if (subsecciones[sub] == 'Comunas') {
        // //   this.AccionCambiarIsComunas(true);
        // } else if (subsecciones[sub] == 'Localidades') {
        //   this.AccionCambiarIsLocalidades(true);

          // Lineas
        // } else if (subsecciones[sub].toLowerCase() == 'booking no planificados') {
        //   this.AccionCambiarIsBokingNoPlanificados(true);
        } else if (subsecciones[sub].toLowerCase() == 'booking declarados') {
          this.AccionCambiarIsBookingDeclarados(true);
        } else if (subsecciones[sub].toLowerCase() == 'bookings solicitados') {
          this.AccionCambiarIsBookingsSolicitados(true);
        } else if (subsecciones[sub].toLowerCase() == 'bookings confirmados') {
          this.AccionCambiarIsBookingsConfirmados(true);
        } else if (subsecciones[sub].toLowerCase() == 'solicitudes modificación') {
          this.AccionCambiarIsSolicitudModificacion(true);
        } else if (subsecciones[sub].toLowerCase() == 'bookings embarcados') {
          this.AccionCambiarIsBookingsEmbarcados(true);
        } else if (subsecciones[sub].toLowerCase() == 'late arrivals') {
          this.AccionCambiarIsLateArrivals(true);
        } else if (subsecciones[sub].toLowerCase() == 'bookings cancelados') {
          this.AccionCambiarIsBookingsCancelados(true);
        } else if (subsecciones[sub].toLowerCase() == 'declarados cancelados') {
          this.AccionCambiarIsVerDeclaradosCancelado(true);
        }

      });

      this.AccionCambiarIsPerfil(true);

    },
    // Obtención da información complementaria
    async getDataDashboard() {
      //
      if (localStorage.getItem("datComplex")) {
        // Obtención de data desde Storage
        let data = JSON.parse(localStorage.getItem("datComplex"));

        // Asignación de valores a State de Vuex
        this.ActionSetPaises(data.lista_paises);
        this.ActionSetZonas(data.lista_zonas);
        this.ActionSetRegiones(data.lista_regiones);
        this.ActionSetProvincias(data.lista_provincias);
        this.ActionSetComunas(data.lista_comunas);
        this.ActionSetLocalidades(data.lista_localidades);
        this.ActionSetDirecciones(data.lista_direcciones);
        this.ActionSetDestinos(data.lista_destino);
        this.ActionSetPuertos(data.lista_puertos);
        this.ActionSetNavieras(data.lista_navieras);
        this.ActionSetNaves(data.lista_naves);

        // Booking Lineas

        this.ActionSetClientes(data.filtro_cliente);
        this.ActionSetComerciales(data.filtro_comercial);
        this.ActionSetProductos(data.filtro_producto);
        this.ActionSetTipoServicioIntegral(data.filtro_tipo_serv_integral);
        this.ActionSetMotivo(data.motivo);
        this.ActionSetListaClientesUsuarioActual(data.lista_clientes_actual);

        // Tarifas

        this.ActionSetCommodity(data.lista_commodity);
        this.ActionSetAtmosferas(data.lista_atmosferas);
        this.ActionSetContenedores(data.filtro_contenedores);
        this.ActionSetEstadoAcuerdoLinea(data.lista_estadoAcuerdoLinea);
        this.ActionSetPod(data.lista_pod);
        this.ActionSetPol(data.lista_pol);
      } else {
        //
        let sql = await getDashboard();

        this.ActionSetListaClientesUsuarioActual(sql.lista_clientes_actual);
        this.ActionSetPaises(sql.lista_paises);
        this.ActionSetZonas(sql.lista_zonas);
        this.ActionSetRegiones(sql.lista_regiones);
        this.ActionSetProvincias(sql.lista_provincias);
        this.ActionSetComunas(sql.lista_comunas);
        this.ActionSetLocalidades(sql.lista_localidades);
        this.ActionSetDirecciones(sql.lista_direcciones);
        this.ActionSetDestinos(sql.lista_destino);
        this.ActionSetPuertos(sql.lista_puertos);
        this.ActionSetNavieras(sql.lista_navieras);
        this.ActionSetNaves(sql.lista_naves);
        // Tarifas
        this.ActionSetCommodity(sql.lista_commodity);
        this.ActionSetAtmosferas(sql.lista_atmosferas);
        this.ActionSetContenedores(sql.filtro_contenedores);

        // Booking Lineas
        this.ActionSetClientes(sql.filtrosBookings.filtro_cliente);
        this.ActionSetComerciales(sql.filtrosBookings.filtro_comercial);
        this.ActionSetProductos(sql.filtrosBookings.filtro_producto);
        this.ActionSetTipoServicioIntegral(
          sql.filtrosBookings.filtro_tipo_serv_integral
        );
        this.ActionSetServicioIntegral(sql.filtroSI);
        this.ActionSetMotivo(sql.motivo);

        // Se guarda información complementaría en localStorage
        localStorage.setItem("datComplex", JSON.stringify(sql));
      }
    },

    async getDataUsuarioAutentificado() {
      this.ActionSetLoading(true);

      // Obtención de valores desde localStorage
      let access_token = await localStorage.getItem("token");
      let user = await JSON.parse(localStorage.getItem("user"));
      let modulos = await JSON.parse(localStorage.getItem("estilos_modulos"));
      let secciones = await JSON.parse(localStorage.getItem("estilos_secciones"));
      let subsecciones = await JSON.parse(localStorage.getItem("estilos_subsecciones"));

      

      // Si existen en localStorage
      if (access_token && user) {

        // Carga avatar thumbnail (Avatar pequeño)
        this.ActionSetAvatarMiniatura( user.avatar_thumbnail ? `http://127.0.0.1:8000/api/getAvatar/${user.id}/${user.avatar_thumbnail}`: null );

        // Guarda registro de token en Vuex
        this.AccionCambiarToken(access_token);


        // Verificación por tipo de perfil
        if (user.rol == "Administrador") {
          this.AccionCambiarAdmin(true);
        }

        // Asignación de acceso a modulos
        this.asignacionPermisosModulos(modulos);

        // Asignación de acceso a secciones
        this.asignacionPermisosSecciones(secciones);

        // Asignación de acceso a subsecciones
        this.asignacionPermisosSubsecciones(subsecciones);

        // 
        this.AccionCambiarUsuarioActual(user);
      }
    },
    async validUser( url ){

      if( url != "/login" ){

          let validateRoute = true ;

          try {
            await validateToken() ;

            validateRoute = true ;
            
          } catch (error) {
            validateRoute = false ;
            localStorage.clear();
            return this.$router.push("/login");
          }

          if( !validateRoute ){
            localStorage.clear();
            return this.$router.push("/login");
          } 
        }
      }
    
  },
  computed: {
    ...mapState(['tokenValidationPage'])
  },

  created() {
    // Get data local storage
    localStorage.getItem("token")
      ? this.getDataUsuarioAutentificado()
      : this.$router.push("/login");


    // Get data para Dashboard
    localStorage.getItem("token") && this.getDataDashboard();

    this.validUser( location.pathname );

  },
  mounted() {
    
  },
  watch:{
    

    tokenValidationPage : async function (_new) {
      this.validUser( _new ) ;
     
    }
  }
};
</script>
